import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const TermsOfService: React.FC = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language.startsWith('zh') ? 'zh' : 'en';

  return (
    <main className="legal-page">
      <nav className="legal-nav">
        <Link to="/" className="legal-brand">{t('home.brand')}</Link>
        <Link to="/" className="legal-back">← {t('common.home')}</Link>
      </nav>

      <div className="legal-container">
        {lang === 'en' ? (
          <>
            <h1>Terms of Service</h1>
            <p className="legal-date">Last updated: June 2025</p>

            <section>
              <h2>1. About Us</h2>
              <p>Incord (UK) is a trading name of Lucky Wheel 11 Ltd. (Company No: 12106600), registered at 169 Great Portland St, London, United Kingdom. By using incord.uk and our services, you agree to these Terms.</p>
            </section>

            <section>
              <h2>2. Services</h2>
              <p>We provide procurement, export clearance, VAT-optimised sourcing, cross-border logistics, and rewards programme services. We act as your UK-based procurement agent — we purchase goods on your behalf, handle export documentation, and arrange international shipping.</p>
            </section>

            <section>
              <h2>3. Account Registration</h2>
              <p>You must register an account to use our services. You are responsible for maintaining the confidentiality of your login credentials and for all activities under your account.</p>
            </section>

            <section>
              <h2>4. Orders & Payments</h2>
              <ul>
                <li>All quotes are VAT-optimised — prices shown are what you pay, with no hidden markups.</li>
                <li>Payment is pre-authorised via Stripe. Funds are only charged once our team confirms your allocation in hand.</li>
                <li>Order cancellations are subject to our refund policy as outlined at the time of purchase.</li>
              </ul>
            </section>

            <section>
              <h2>5. Shipping & Customs</h2>
              <p>We handle customs clearance and export documentation from the UK. Import duties, taxes, and customs clearance at the destination country are the responsibility of the buyer. We recommend checking your local import regulations before placing an order.</p>
            </section>

            <section>
              <h2>6. Rewards Programme</h2>
              <p>Members earn 5% cash reward points on captured order values. Rewards are credited after successful delivery and may be redeemed on future purchases or withdrawn subject to minimum thresholds. Terms are subject to change with 30 days' notice.</p>
            </section>

            <section>
              <h2>7. Limitation of Liability</h2>
              <p>Lucky Wheel 11 Ltd. shall not be liable for any indirect, incidental, or consequential damages arising from the use of our services, including but not limited to shipping delays, customs holds, or currency fluctuations. Our total liability is limited to the value of the order in question.</p>
            </section>

            <section>
              <h2>8. Governing Law</h2>
              <p>These Terms are governed by the laws of England and Wales. Any disputes shall be resolved in the courts of England and Wales.</p>
            </section>

            <section>
              <h2>9. Contact</h2>
              <p>
                <strong>Lucky Wheel 11 Ltd.</strong><br />
                Registered Office: 169 Great Portland St, London, United Kingdom.<br />
                Email: <a href="mailto:hello@incord.uk">hello@incord.uk</a><br />
                Company No: 12106600
              </p>
            </section>
          </>
        ) : (
          <>
            <h1>服務條款</h1>
            <p className="legal-date">更新日期：2025年6月</p>

            <section>
              <h2>1. 關於我們</h2>
              <p>Incord (UK) 為 Lucky Wheel 11 Ltd. 之交易名稱（公司註冊號：12106600），註冊地址為 169 Great Portland St, London, United Kingdom。使用 incord.uk 及我們的服務即表示您同意本條款。</p>
            </section>

            <section>
              <h2>2. 服務內容</h2>
              <p>我們提供採購代理、出口報關、稅務優化採購、跨境物流及紅利計劃服務。我們作為您的英國採購代理——代您購買商品、處理出口文件並安排國際運送。</p>
            </section>

            <section>
              <h2>3. 帳戶註冊</h2>
              <p>您必須註冊帳戶才能使用我們的服務。您有責任維護您的登入憑證的機密性，並對您帳戶下的所有活動負責。</p>
            </section>

            <section>
              <h2>4. 訂單與付款</h2>
              <ul>
                <li>所有報價均已含 VAT 優化——顯示價格即為您需支付的金額，無隱藏費用。</li>
                <li>付款透過 Stripe 預先授權。只有在倫敦團隊確認庫存到位後才會正式扣款。</li>
                <li>取消訂單需遵守購買時說明的退款政策。</li>
              </ul>
            </section>

            <section>
              <h2>5. 運送與關務</h2>
              <p>我們負責英國出口報關及文件處理。目的地國家的進口關稅、稅費及通關程序由買方負責。建議下單前查詢當地進口法規。</p>
            </section>

            <section>
              <h2>6. 紅利計劃</h2>
              <p>會員可獲得訂單金額 5% 的現金回饋點數。紅利在成功送達後入帳，可在未來採購時兌換或依最低門檻提領。條款如有變更將提前 30 天通知。</p>
            </section>

            <section>
              <h2>7. 責任限制</h2>
              <p>Lucky Wheel 11 Ltd. 不對因使用我們的服務所產生的任何間接、附帶或衍生性損害負責，包括但不限於運送延遲、海關扣留或匯率波動。我們的總責任上限為相關訂單的金額。</p>
            </section>

            <section>
              <h2>8. 管轄法律</h2>
              <p>本條款受英格蘭及威爾斯法律管轄。任何爭議應提交英格蘭及威爾斯法院裁決。</p>
            </section>

            <section>
              <h2>9. 聯絡資訊</h2>
              <p>
                <strong>Lucky Wheel 11 Ltd.</strong><br />
                註冊地址：169 Great Portland St, London, United Kingdom.<br />
                電子郵件：<a href="mailto:hello@incord.uk">hello@incord.uk</a><br />
                公司註冊號：12106600
              </p>
            </section>
          </>
        )}
      </div>

      <footer className="legal-footer">
        <div className="container">
          <Link to="/" style={{ color: 'var(--accent-gold)', textDecoration: 'none' }}>← {t('common.home')}</Link>
        </div>
      </footer>
    </main>
  );
};

export default TermsOfService;
